export default function ImageBox({
  src,
  style,
  imgStyle,
  link = true,
  onClick,
}) {
  const ImageContainer = (
    <div
      style={{
        height: "85px",
        width: "85px",
        border: "2px solid #DEE2DF",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        borderRadius: "8px",
        margin: "5px 10px 10px 0px",
        background: "white",
        transition: "0.5s",
        ...style,
      }}
    >
      <img
        src={src}
        alt="test"
        style={{
          height: "80px",
          width: "80px",
          objectFit: "contain",
          padding: "0px 5px",
          ...imgStyle,
        }}
      />
    </div>
  );

  return link ? (
    <a href={src} target="_blank" rel="noreferrer">
      {ImageContainer}
    </a>
  ) : (
    <div
      onClick={onClick}
      onMouseDown={(e) => {
        if (e.button === 1) {
          window.open(src, "_blank", "noopener,noreferrer");
        }
      }}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      {ImageContainer}
    </div>
  );
}
